import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaFacebookF,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

const contactData = {
  phoneNumber: "9884845532",
  whatsappMessage: "Hello, I'm interested in ordering crackers!",
  email: "Prinicrackers2025@gmail.com",
  instagram: "Prinicrackers2025",
  facebook: "prinicrackers",
  location: "Sivakasi, Tamil Nadu",
  hours: "9:00 AM – 8:00 PM IST",
  contacts: [
    {
      type: "phone",
      label: "Phone",
      href: (phone) => `tel:+91${phone}`,
      display: (phone) => `+91 ${phone}`,
      icon: FaPhoneAlt,
      ariaLabel: (phone) => `Call +91 ${phone}`,
    },
    {
      type: "whatsapp",
      label: "WhatsApp",
      href: (phone, msg) =>
        `https://wa.me/+91${phone}?text=${encodeURIComponent(msg)}`,
      display: (phone) => `+91 ${phone}`,
      icon: FaWhatsapp,
      ariaLabel: () => "Chat on WhatsApp",
      iconClassName: "whatsapp-icon",
      extraParams: ["phoneNumber", "whatsappMessage"],
    },
    {
      type: "email",
      label: "Email",
      href: (email) => `mailto:${email}`,
      display: (email) => email,
      icon: FaEnvelope,
      ariaLabel: (email) => `Send email to ${email}`,
    },
    {
      type: "instagram",
      label: "Instagram",
      href: (username) => `https://instagram.com/${username}`,
      display: (username) => `@${username}`,
      icon: FaInstagram,
      ariaLabel: () => "Visit Instagram",
    },
    {
      type: "facebook",
      label: "Facebook",
      href: (username) => `https://facebook.com/${username}`,
      display: (username) => username,
      icon: FaFacebookF,
      ariaLabel: () => "Visit Facebook",
    },
    {
      type: "location",
      label: "Location",
      href: (loc) => "https://maps.app.goo.gl/fKe55HqnPiCE1FRe6",
      display: (loc) => loc,
      icon: FaMapMarkerAlt,
    },
    {
      type: "hours",
      label: "Hours",
      display: (hours) => hours,
      icon: FaClock,
      isTextOnly: true,
    },
  ],
};

export default contactData;